import styled from "styled-components/macro";
import React, {useEffect} from 'react';
import useWindowDimensions from "../../utils/dimensions";

const AdsenseUnderPost = styled(({className}) => {
    useEffect(() => {
        if (window) {
            (window.adsbygoogle = window.adsbygoogle || []).push({});
        }
    }, []);

    const {width} = useWindowDimensions();
    const adWidth = width > 1080 ? 728 : 300;
    const adHeight = width > 1080 ? 90 : 50;
    const adClient = width > 1080 ? "5433240839183569" : "5433240839183569";
    const adSlot = width > 1080 ? "6306619900" : "1614133215";

    return (
        <div className={`${className} sponsored ad ad-unit google-ad googleAd google-sponsored-links ads4 fullSizeAd`}>
            <ins
                className="adsbygoogle"
                style={{ display: 'inline-block', width: adWidth, height: adHeight }}
                data-ad-client={`ca-pub-${adClient}`}
                data-ad-slot={adSlot} />
        </div>
    );
})`
  margin-top: 6px;
  margin-bottom: 6px;
  display: flex;
  text-align: center;
  justify-content: center;
`;

export default AdsenseUnderPost;